import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedKiloGLMFlowListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

function useGLMKiloFlows(): UseInfiniteQueryResult<AxiosResponse<PaginatedKiloGLMFlowListList>> {
  const fetchGLMKiloFlows = ({
    pageParam = { limit: '20', offset: '0' },
  }: {
    pageParam?: { limit: string; offset: string };
  }): Promise<AxiosResponse<PaginatedKiloGLMFlowListList>> => {
    return client.get(`glm-kilo-flows/?${encodeUrlParams(pageParam)}`);
  };
  return useInfiniteQuery(['glm-kilo-flows'], fetchGLMKiloFlows, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}
export default useGLMKiloFlows;
